import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Button, Tabs, Spin, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { getBranches } from '../api/branches';
import useAuthStore from '../store/authStore';
import TermsTab from '../components/settings/TermsTab';
import ClassroomsTab from '../components/settings/ClassroomsTab';
import CampaignsTab from '../components/settings/CampaignsTab';
import BranchCoursesTab from '../components/settings/BranchCoursesTab';

const { TabPane } = Tabs;

const BranchDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuthStore();
  const defaultTab = location.state?.activeTab || 'terms';
  const [branch, setBranch] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // branch_manager sadece kendi şubesine erişebilir
    if (user?.role === 'branch_manager' && user?.branch_id && String(user.branch_id) !== String(id)) {
      message.error('Bu şubeye erişim yetkiniz yok.');
      navigate('/branches');
      return;
    }

    const fetchBranch = async () => {
      try {
        const res = await getBranches({ per_page: 200 });
        const found = res.data.data.find(b => String(b.id) === String(id));
        if (found) {
          setBranch(found);
        } else {
          message.error('Şube bulunamadı.');
          navigate('/branches');
        }
      } catch {
        message.error('Şube bilgisi yüklenemedi.');
        navigate('/branches');
      } finally {
        setLoading(false);
      }
    };
    fetchBranch();
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center" style={{ minHeight: 200 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/branches')}>
          Şubeler
        </Button>
        <h2 className="text-2xl font-bold m-0">{branch?.name}</h2>
        {branch?.address && (
          <span className="text-gray-500 text-sm">{branch.address}</span>
        )}
      </div>

      <Tabs defaultActiveKey={defaultTab}>
        <TabPane tab="Dönemler" key="terms">
          <TermsTab branchId={Number(id)} />
        </TabPane>
        <TabPane tab="Derslikler" key="classrooms">
          <ClassroomsTab branchId={Number(id)} />
        </TabPane>
        <TabPane tab="Kampanyalar" key="campaigns">
          <CampaignsTab branchId={Number(id)} />
        </TabPane>
        <TabPane tab="Sertifika Programları" key="courses">
          <BranchCoursesTab branchId={Number(id)} />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default BranchDetail;
